<template>
  <div class="container">
    <div class="bg"></div>
    <div class="top" style="display: flex;justify-content: space-between;">
      <div style="width:100%;max-width:1200px;margin:0px auto;">
        <div style="margin-top: 18px;color: white;margin-right: 20px;position: absolute;right: 0px;font-size: 15px;">
          <router-link :to="{name:'Complain_info'}" style="color: white;">投诉建议</router-link>
        </div>
        <div class="logo">
          <router-link to='/'><img src="../assets/logo.png"></router-link>
        </div>
        <!--        <ul class="pc pcnav">-->
        <!--          <li class="currents">-->
        <!--            <router-link :to="{name:'Common_product'}">产品介绍</router-link>-->
        <!--          </li>-->
        <!--          <li>-->
        <!--            <router-link :to="{name:'Common_introduce'}">公司介绍</router-link>-->
        <!--          </li>-->
        <!--          <li>-->
        <!--            <router-link :to="{name:'Common_video'}">实时监控</router-link>-->
        <!--          </li>-->
        <!--          <li>-->
        <!--            <router-link :to="{name:'Common_drew'}">码上有礼</router-link>-->
        <!--          </li>-->
        <!--        </ul>-->
        <div class="qh" style="margin-top: 18px;color: white;margin-right: 20px;">
          <a href="javascript:void(0)" @click="getIntegral" class="integral-btn"><img
            style="width:20px;vertical-align: text-bottom;" src="../assets/icon-jifen.png"/>积分获取</a>
        </div>
      </div>
    </div>
    <!--   <ul class="nav">-->
    <!--      <li style="position: relative" class="current">-->
    <!--        <router-link :to="{name:'Common_product'}">产品介绍</router-link>-->
    <!--        <p class="ui-line"></p>-->
    <!--      </li>-->
    <!--      <li>-->
    <!--        <router-link :to="{name:'Common_introduce'}">企业介绍</router-link>-->
    <!--      </li>-->
    <!--      <li style="position: relative">-->
    <!--        <router-link :to="{name:'Common_video'}">实时监控</router-link>-->
    <!--      </li>-->
    <!--      <li style="position: relative">-->
    <!--        <router-link :to="{name:'Common_drew'}">码上有礼</router-link>-->
    <!--      </li>-->
    <!--    </ul>-->
    <div class="cs">
      <div class="cs-b">
        <!-- <span>产品溯源信息</span> -->
        <span>
          当前为第<b style="color: red">{{times}}</b>次查询
        </span>
      </div>

    </div>
    <div class="store">
      <h3 style="font-weight: bold">产品身份证信息</h3>
      <div class="productInfo" style="text-indent: 0">
        <p><span>交易HASH:</span>0x2c4b3af3ab95693c48b40da14d4cd830ef96f99bb01b28bf83051a41655cd78a</p>
      </div>
      <div class="productInfo" style="text-indent: 0">
        <p><span>上 链 时 间:</span> 2021/10/02         10:20:25</p>
      </div>
      <p class="productInfo">您所查询的防伪码已被查询54次，谨防假冒！如有疑问请联系生产企业或致电400-008-8688。</p>
    </div>
    <div class="store">
      <h3 style="font-weight: bold">产品标识对比</h3>
      <div style="font-size:0.6rem;width: 100%;line-height: 1rem;margin-top: 0.5rem;text-indent: 20px;text-align: left">
        {{productData.pdesc}}
      </div>
    </div>
    <div class="pc pcintroduce">
      <h2>产品简介</h2>
      <div class="nr">
        {{productData.pdesc}}
      </div>
      <div class="jb">
        <p>
          <span style="color: #45b035">产品品牌</span>:{{productData.brandName}}
        </p>
        <p>
          <span style="color: #45b035">产品名称</span>:{{productData.pname}}</p>
        <p>
          <span style="color: #45b035">真源码</span>:{{num}}</p>
        <p>
          <span style="color: #45b035">产品等级</span>:{{productData.pgrade}}</p>
        <p>
          <span style="color: #45b035">产品价格</span>:{{productData.pprice}}</p>
        <p>
          <span style="color: #45b035">产品保质期</span>:{{productData.expiryDay}}</p>
        <p v-if="productData.hashCount > 0">
          <span style="color: #45B035;">区块链</span>:本信息已上链 <a style="color: #009900;" href="https://eth.tokenview.com/"
                                                             target="view_window">验证</a>
        </p>
      </div>
    </div>
    <div class="pc pcintroduce" style="padding-bottom: 20px;min-height: 330px;">
      <h2>生产追溯</h2>
      <ul class="cp">
        <li class="dg" v-for="(item,index) in suyuandata.batchSuyuanNodeDetailDataVOS">
          <!-- <div class="dg-head">
            <div style="">
              {{index+1}}
            </div>
            <div style="">
              {{item.nodeName}}
            </div>
          </div>
          <div v-for="(item1,index1) in item.batchSuyuanNodeDataDomians" >
            <div>
              <div class="js">
                <p><span>{{item1.cname}}:</span><span style="">{{item1.cvalue}}</span></p>
              </div>
                <Carousel autoplay :dots="setting.dots">
                  <CarouselItem v-for="(item2,index2) in item1.complexMap">
                    <div class="demo-carousel">
                      <img :src="item2.url">
                    </div>
                  </CarouselItem>
                </Carousel>
            </div>
          </div> -->
          <div>
            <div class="dg-head">
              <div style="">
                {{index+1}}
              </div>
              <div style="">
                {{item.nodeName}}
              </div>
            </div>
            <div class="sj" style="display: flex;justify-content: space-between">
              <div
                style="width: 60%;"
                class="">
                <div class="js" v-for="(item1,index1) in item.batchSuyuanNodeDataDomians"
                     v-if="item1.complexMap!='' && item1.formType!=4">
                  <p><span>{{item1.cname}}:</span><span style="">{{item1.cvalue}}</span></p>
                </div>
                <div v-if="item.ethHash" style="overflow: hidden; margin-top: 20px;">
                  <p class="tt1" style="font-size: 0.8rem;width: 25%;text-align: left">HASH码</p>
                  <div style="width: 75%">
                    <div class="pic1"
                         style="width: 85%;text-align: left;margin-bottom: 20px; line-height: 20px; overflow: hidden;text-overflow: ellipsis;float: left;">
                      {{item.ethHash}}
                    </div>
                    <div style="width: 15%;float: right;">
                      <span v-clipboard:copyEvent="item.ethHash" v-clipboard:success="onCopy"
                            v-clipboard:error="copyError" class="copy-btn"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="width: 40%;"
                class=""
                v-for="(item1,index1) in item.batchSuyuanNodeDataDomians"
                v-if="item1.complexMap!='' && item1.formType==4">
                <Carousel autoplay :dots="setting.dots">
                  <CarouselItem v-for="(item2,index2) in item1.complexMap">
                    <div class="demo-carousel">
                      <img :src="item2.url">
                    </div>
                  </CarouselItem>
                </Carousel>
              </div>

            </div>

          </div>
        </li>
      </ul>
    </div>
    <cp-footer></cp-footer>
  </div>
</template>

<script>
  import cpFooter from "@/views/footer";

  export default {
    name: 'Common_product',
    components: {
      cpFooter,
    },
    data() {
      return {
        unitList: [],
        setting: {
          dots: 'inside'
        },
        modal1: false,
        num: '4305280000140000055001',
        times: '',
        productData: {},
        suyuan: [],
        suyuandata: [],
        menu_show: false,
        menu_show1: false,
        false1: false,
        selectedLabelDefault: '首页',
        selectedLabelDefault1: '基本信息',
        type: true,
        tabs1: [
          {
            label: '基本信息'
          },
          {
            label: '生产追溯'
          }
        ],
        tabs: [
          {
            label: '首页',
            icon: 'cubeic-home'
          },
          {
            label: '我的',
            icon: 'cubeic-person'
          }
        ],
        items: []
      };
    },
    created() {
      this.num = "4305280000140000055001";
      this.times = localStorage.getItem('suyuanCount');
      this.getList();
      this.getListsuyuan();
      this.integralData();
    },
    watch: {
      '$route': 'integralData'
    },
    methods: {
      //复制粘贴成功
      onCopy(e) {
        this.$Message.success("复制成功!");
      },
      //复制粘贴失败
      copyError(e) {
        this.$Message.error("复制失败!");
      },
      getList() {
        this.$axios({
          method: 'get',
          url: 'portal/suyuan/getProductInfo/' + this.num
        })
          .then(res => {
            this.productData = res.data.data;
            this.items = res.data.data.productImgUrls;
            if (this.productData.outgoingTime && this.productData.outgoingTime != "") {
              let day = 0;
              if (this.productData.expiryDayUnit == 1) {
                day = this.productData.expiryDay;
              } else if (this.productData.expiryDayUnit == 2) {
                day = this.productData.expiryDay * 30;
              } else {
                day = this.productData.expiryDay * 365;
              }

              let startTime = new Date(this.productData.outgoingTime); // 开始时间
              let endTime = new Date(); // 结束时间
              let usedTime = endTime - startTime; // 相差的毫秒数
              let days = Math.floor(usedTime / (24 * 3600 * 1000)); // 计算出天数
              if (days >= day) {

                this.$Message.error("该产品可能已过期，请勿食用!", 2000);
              }
            }
            // console.log('this.productData', this.productData)
            // console.log('this.items', this.items)
          })
          .catch(err => {
          });
      },
      getListsuyuan() {
        this.$axios({
          method: 'get',
          url: 'portal/suyuan/getSuyuanInfo/' + this.num
        })
          .then(res => {
            this.suyuandata = res.data.data;
            // console.log('生产溯源数据', this.suyuandata.batchSuyuanNodeDetailDataVOS)
          })
          .catch(err => {
          });
      },
      open(data) {
        this.modal1 = true;
        this.suyuan = data.batchSuyuanNodeDataDomians;
        // console.log(data);
      },
      showmenu1() {
        if (this.menu_show1 == true) {
          this.menu_show1 = false;
        } else if (this.menu_show1 == false) {
          this.menu_show1 = true;
        }
      },
      changeHandler(label) {
        if (label == '我的') {
          this.$router.push({path: 'Center'});
        } else {
          this.$router.push({path: 'Index'});
        }
      },
      showmenu() {
        if (this.menu_show == true) {
          this.menu_show = false;
        } else if (this.menu_show == false) {
          this.menu_show = true;
        }
      },
      getIntegral() {
        var _this = this;
        var wx_code = _this.$route.query.code;
        var wx_state = _this.$route.query.state;
        if (!wx_code && !wx_state) {
          _this.$axios({
            method: "get",
            url: "portal/integral/verify/count/" + _this.num
          })
            .then(res => {
              if (res.data.code == 0) {
                if (res.data.data <= 0) {
                  var appid = "wxfe3edde0e854125b";
                  var scope = "snsapi_userinfo";
                  var auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope=' + scope + '&state=' + _this.num + '#wechat_redirect';
                  window.location.replace(auth_url);
                } else {
                  _this.$Message.error("此积分已被获取!");
                }
              } else {
                _this.$Message.error(res.data.msg);
              }
            })
            .catch(err => {
              alert(err);
              console.log(err);
            });
        } else {
          _this.$Message.error("您已获取积分!");
        }
      },
      integralData() {
        var _this = this;
        var wx_code = _this.$route.query.code;
        var wx_state = _this.$route.query.state;
        if (wx_code && wx_state) {
          _this.$axios({
            method: "get",
            url: "portal/integral/verify/count/" + _this.num
          })
            .then(res => {
              if (res.data.code == 0) {
                if (res.data.data <= 0) {
                  _this.$axios({
                    method: "post",
                    url: "portal/integral/add/integral/" + _this.num + "?code=" + wx_code,
                    headers: {
                      "Content-Type": "application/json"
                    }
                  })
                    .then(res => {
                      if (res.data.code == 0) {
                        _this.$Message.success(res.data.msg);
                      } else {
                        _this.$Message.error(res.data.msg);
                      }
                    })
                    .catch(err => {
                      alert(err);
                      console.log(err);
                    });
                }
              } else {
                _this.$Message.error(res.data.msg);
              }
            })
            .catch(err => {
              alert(err);
              console.log(err);
            });
        }
      }
    }
  };

</script>

<style scoped>
  * {
    padding: 0;
    margin: 0;
  }

  body {
    background-color: #f5f5f5;
  }

  .pcfooter {
    display: none !important;
  }

  .pic1 img {
    width: 100%;
  }

  .cs {
    padding: 0 0.8rem;
  }

  .cs span {
    display: block;
    font-size: 0.8rem;
  }

  .cs-b {
    display: flex;
    justify-content: space-between;
    align-content: center;
    padding: .8rem 0;
    border-bottom: 1px solid #f5f5f5;
  }

  .productInfo {
    font-size: 14px;
    width: 100%;
    line-height: 1rem;
    margin-top: 0.5rem;
    text-indent: 20px;
    text-align: left;
    display: flex;
    flex-direction: column;
  }

  .productInfo p span {
    width: 80px;
    text-align: right;
    display: inline-block;
    margin-right: 5px;
  }

  .top {
    height: 3rem;
    background-color: #45b035;
  }

  .logo {
    width: 25%;
    margin: 0px auto;
    line-height: 3rem;
  }

  .logo > a {
    display: inline-block;
    margin-top: 10%;
  }

  .logo img {
    display: block;
    width: 100%;
  }

  .ivu-timeline-item-tail {
    left: 10px !important;
    top: 23px !important;
  }

  .tab {
    position: fixed;
    width: 100%;
    bottom: 0;
    border-top: 1px solid #f1ebeb;
    background-color: white;
  }

  .nav {
    list-style: none;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f1ebeb;
    background-color: white;
  }

  .nav a {
    color: #333333;
    margin: 12px 0;
    display: inline-block;
  }

  .nav .ui-line {
    width: 1.12rem;
    height: 0.1rem;
    background-color: #39BF3E;
    margin: 0px auto;
  }

  .nav li {
    width: 33%;
  }

  .nav li:hover {
    color: #45b035;
  }

  .current a {
    color: #45b035;
  }

  .banner img {
    width: 100%;
  }

  .introduce {
    text-align: left;
    font-size: 0.8rem;
    color: #999999;
    padding: 0rem 1rem;
    background-color: white;
    margin: 0 0.5rem;
    padding: 0.8rem;
    border-radius: 6px;
    z-index: 1;
    position: relative;
    top: -20px;
  }

  .introduce p {
    margin-bottom: 0.5rem;
  }

  .store {
    background-color: white;
    padding: 0.8rem;
  }

  h3 {
    font-size: 0.9rem;
    text-align: left;
    position: relative;
    padding-left: 20px;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 10px;
  }

  h3:before {
    position: absolute;
    content: '';
    left: 5px;
    top: 0;
    width: 3px;
    height: 16px;
    background-color: #45b035;
  }

  .img_content {
    display: flex;
    margin: 10px 0;
    justify-content: space-around;
  }

  .store p {
    width: 30%;
  }

  .store p img {
    width: 100%;
  }

  .list {
    padding-bottom: 60px;
    margin-top: 10px;
  }

  .left_img {
    width: 30%;
  }

  .left_img img {
    width: 100%;
  }

  .list_content {
    display: flex;
    padding: 5px;
    margin-top: 10px;
    box-shadow: 0px 0px 3px #ece6e6;
  }

  .title {
    width: 70%;
    text-align: left;
  }

  h4 {
    font-size: 1rem;
    margin-top: 1.3rem;
    color: #2c3e50;
    margin-left: 1rem;
  }

  .sub {
    font-size: 0.8rem;
    margin-top: 1.3rem;
    color: red;
    margin-left: 1rem;
  }

  .more {
    float: right;
    color: #b8b8b8;
    font-size: 0.8rem;
  }

  .look {
    float: right;
    color: #45b035;
  }

  .it {
    font-size: 0.6rem;
    margin: 5px 0;
    margin-left: 1rem;
  }

  .ej {
    position: absolute;
    width: 100%;
    background-color: #45b035;
    left: 0;
    top: 38px;
    z-index: 100;
    text-align: right;
  }

  .ej li {
    width: 100%;
    text-align: center;
    color: white;
    border-bottom: 1px solid #fff;
  }

  .ej li a {
    width: 100%;
    text-align: center;
    color: white;
  }

  .ej li a:hover {
    color: white;
  }

  .cube-tab-bar-slider {
    background-color: #45b035 !important;
  }

  .jb {
    color: #5a5757;
    padding: 0.5rem 0.6rem;
    text-align: left;
    font-size: 0.8rem;
  }

  .jb li {
    margin-top: 0.3rem;
  }

  .jb li h4 {
    text-align: center;
    margin: 0.8rem 0;
  }

  .pc {
    display: none;
  }

  .qh {
    display: none;
  }

  .ts li {
    width: 48%;
    text-align: left;
    overflow: hidden;
  }

  .ts li span {
    text-align: left;
  }

  .sj {
    display: flex;
    justify-content: space-between;
  }

  .tt {
    width: 50% !important;
  }

  .pic {
    width: 80%;
    text-align: right;
    display: flex;
  }

  .pic img {
    width: 100%;
    height: 100%;
  }

  .footer {
    display: block;
    margin-top: 40px;
    text-align: center;
    border-top: 8px solid #45b035;
  }

  .footer p {
    font-size: 14px;
  }

  .footer p > a {
    color: #45b035;
  }

  .store p {
    width: 100%;
    float: left;
    /*margin-top: 0.2rem;*/
  }

  .copy-btn {
    display: inline-block;
    width: 17px;
    height: 17px;
    background: url(../assets/copy-icon.png) no-repeat;
    background-size: 100%;
    /* margin-left: 10px; */
  }

  /* @media screen and (min-width: 1000px) {
    .cs-b{
      border-bottom: none;
    }
    .cs {
      margin: 2rem auto 0;
      max-width: 1200px;
      width: 100%;
    }
    .top {
      background: #45b035;
      height: 2rem;
    }
    .logo {
      width: 160px;
      margin-left: 20px;
      line-height: 3rem;
      float: left;
    }
    .logo > a{
      display: inline-block;
      margin-top: 10px;
    }
    .footer {
      display: none;
    }
    .content {
      display: none;
    }
    .img {
      width: 40%;
      margin: 0 auto;
    }
    .img img {
      width: 80%;
    }
    .ct {
      width: 88%;
      display: flex;
      margin: 8% auto;
      justify-content: space-around;
    }
    .rt {
      width: 60%;
    }
    .name {
      font-size: 1rem;
    }
    .wz {
      margin-top: 0.7rem !important;
    }
    .it {
      margin-top: 0.8rem !important;
    }
    .qh {
      display: block;
      float: right;
    }
    .pc {
      display: block;
    }
    .qh{
      display: block;
    }
    .footer {
      margin-top: 40px;
      text-align: center;
      border-top: 8px solid #45b035;
    }
    .pcnav {
      width: 400px;
      display: flex;
      font-size: 18px;
      color: white;
      line-height: 2rem;
      justify-content: space-between;
      float: left;
      margin-left: 100px;
    }
    .pcnav a {
      color: white;
    }
    .nav {
      display: none;
    }
    .introduce {
      display: none;
    }
    .store {
      display: none;
    }
    .pcintroduce {
      margin: 60px auto;
      overflow: hidden;
      overflow-x: auto;
      max-width: 1200px;
      width: 100%;
    }
    .pcintroduce h2 {
      text-align: center;
      color: #333;
      padding-bottom: 26px;
      font-size: 32px;
      color: #333;
      background: url(../assets/line_01.png) no-repeat center bottom;
    }
    .bg {
      display: none;
    }
    .nr {
      max-width: 1200px;
      width: 100%;
      margin: 20px auto;
      text-align: left;
      line-height: 24px;
      font-size: 14px;
    }
    .jb {
      font-size: 16px;
      text-align: left;
      max-width: 1200px;
      width: 100%;
      margin: 10px auto;
  //   display: flex;
    //  justify-content: space-between;
    }
    .jb p{
      margin: 20px auto;
    }
    .top {
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 1000;
    }
    .pcfooter {
      display:  block !important;
      margin-top: 100px;
      text-align: center;
      border-top: 8px solid #45b035;
    }
    .cp {
      max-width: 1200px;
      width: 100%;
      margin: 20px auto;
      padding: 10px 0;
    }
    .dg {
      padding: 10px;
      width: 48%;
      margin: 10px auto;
      border-radius: 6px;
      position: relative;
      float: left;
      margin-left: 20px;
      justify-content: space-between;
      box-shadow: 0 0 10px #c7c9cc;
    }
    .tp {
      width: 30%;
    }
    .tp img {
      width: 100%;
    }
    .js {
      font-size: 14px;
      display: flex;
      justify-content: space-around;
      flex-flow: wrap column;
      align-items: center;
      margin-left: 10px;
    }
    .js p{
      display: flex;
      width: 100%;
      text-align: left;
      margin-bottom: 5px;
    }
    .js p span:nth-of-type(1) {
      width: 70px;
      text-align: right;
    }
    .js p span:nth-of-type(2) {
      margin-left: 6px;
      flex: 1;
    }
    .pcnav .currents {
      position: relative;
    }
    .pcnav .currents:after {
      position: absolute;
      content: '';
      left: 0;
      bottom: 15px;
      height: 3px;
      width: 100%;
      background-color: #fff;
    }
    .currents a {
      color: #fff;
    }



  } */
</style>
<style lang="scss" scoped>
  @import '@/assets/css/rem.scss';

  .banner img {
    height: rem(550);
  }

  .dg-head {
    display: flex;
    border-bottom: 1px solid #d7dde4;
    margin-bottom: 10px;
    align-items: center;

    > div {
      &:nth-of-type(1) {
        margin-left: 12px;
        font-size: 14px;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        background-color: #45b035;
        color: white;
        line-height: 20px;
      }

      &:nth-of-type(2) {
        font-size: 16px;
        color: #45b035;
        font-weight: bold;
        padding: 10px;
        flex: 1;
      }
    }
  }

  .integral-btn-wrapper {
    width: 400px;
    padding: 50px;
    background-color: yellow;
  }

  .integral-btn {
    color: white;
    background: #DFAB04;
    height: 58px;
    border: 2px solid #C1AC0E;
    font: 500 20px "Raleway", "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 0 10px;
    transition: color 0.1s linear, background-color 0.1s linear, border-color 0.1s linear;
    -moz-border-radius: 10px;
    -webkit-border-radius: 10px;
    border-radius: 10px;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .integral-btn:hover {
    background: #C1AC0E;
    border-color: #C1AC0E;
  }

  .integral-btn:active {
    background: #45B035;
    border-color: #C1AC0E;
  }
</style>



// WEBPACK FOOTER //
// src/components/Common_scan.vue